import React from 'react'
import { useDispatch } from 'react-redux'

import { useSettingsPopupState } from '../hooks'
import { CustomFormPopup } from '../CustomFormPopup'
import { QuestionStepSchema } from '@feedyou/schema'
import { ModalDescriptorForType } from '../../../store/modals'
import { runNlpTestForStepThunk } from '../../../features/nlpTester'
import { schema, uiSchema } from './constants'
import { modalsActions } from '../../../store/modals/modalsSlice'

type Props = {
  modalDescriptor: ModalDescriptorForType<'fuzzy_question_nlp_test'>
}
export const FuzzyQuestionTestPopup: React.FC<Props> = ({ modalDescriptor }) => {
  const dispatch = useDispatch()
  const { formData = '', onFormDataChange } = useSettingsPopupState(() => undefined) as any
  const close = () => dispatch(modalsActions.closeModal())

  return (
    <CustomFormPopup<string>
      title="NLP Tester - Enter test cases"
      formData={formData}
      onChange={onFormDataChange}
      labels={{ buttons: { submit: 'Run test' } }}
      onSubmit={formData => {
        if (formData?.trim()) {
          dispatch(
            runNlpTestForStepThunk(formData, modalDescriptor.stepOrSubstep as QuestionStepSchema)
          )

          close()
        }
      }}
      schema={schema}
      uiSchema={uiSchema}
      validateSchema={(formData, errors) => {
        if (!formData?.trim()) {
          errors.addError('Please enter test cases into the text area in described format.')
        }

        return errors
      }}
    />
  )
}
